/* eslint-disable import/no-named-as-default */
import React from 'react';
import { array, object, oneOfType, string } from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import classNames from 'classnames/bind';

import Accordion from 'yoda-core-components/lib/components/Accordion/accordion';

import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import LoaderAction from 'yoda-site-components/lib/actions/LoadingAction';

import { selectProductReviewID } from 'yoda-site-components/lib/selectors/ProductDetailsSelector';
import { selectPreferences } from 'yoda-site-components/lib/selectors/ContextSelector';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ProductInfoSelector, {
    getProductMattressSpec,
} from '../../selectors/ProductInfo/ProductInfoSelector';

import { pdpToolClickAnalytics } from '../../actions/AnalyticsAction';
import { CONSTANTS, renderMobileAccordion } from '../BazaarVoice/RenderBazaarVoice';

import * as styles from './ProductInfo.css';

const cx = classNames.bind(styles);
let reviewsAccordionIdx;
let questionsIdx;
let buttonRendered = false;
let pageLoadStatus = '';

class ProductInfo extends SiteComponent {
    static propTypes = {
        actions: oneOfType([object, array]),
        dataAutomationId: string,
        productReviewID: string,
        productDetails: oneOfType([object, array]).isRequired,
    };

    static defaultProps = {
        actions: {},
        dataAutomationId: '',
        productReviewID: '',
        productDetails: {},
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);

        this.mobileTabletRenderer = this.mobileTabletRenderer.bind(this);
        this.handleAccordionAnalytics = this.handleAccordionAnalytics.bind(this);
        this.state = {
            activeNode: 'prodDesc',
            initializeTurnToLib: false,
            showReviews: false,
        };
        this.bvReviewRef = React.createRef(null);
    }

    /* istanbul ignore next */
    observer =
        !__SERVER__ &&
        new MutationObserver(() => {
            if (this.bvReviewRef.current.shadowRoot) {
                const bvReviewMainContainer = this.bvReviewRef.current.shadowRoot.querySelector(
                    '#bv_review_maincontainer'
                );
                const divsUnderReviewMainContainer =
                    bvReviewMainContainer && bvReviewMainContainer.children;
                const showReviewsButtonContainer = document.querySelector('#BVReviewsContainer');

                if (!buttonRendered) {
                    const buttonClasses = dt([
                        'my-6',
                        'mx-auto',
                        'w-auto',
                        'smOnly:w-full',
                        'p-2',
                        'border-solid',
                        'border',
                        'border-gray-40',
                        'rounded-lg',
                        'flex',
                        'smOnly:block',
                        'text-base',
                        'text-center',
                        'font-semibold',
                        'hover:bg-light-white',
                    ]);
                    const showReviewsButton = `<button id=\"showReviews\" class=\"${buttonClasses}\">${CONSTANTS.btnLabel}</button>`;
                    showReviewsButtonContainer.insertAdjacentHTML('beforeend', showReviewsButton);
                    showReviewsButtonContainer
                        .querySelector('button')
                        .addEventListener('click', this.onShowReviewsClick);
                    buttonRendered = true;
                }

                if (divsUnderReviewMainContainer && divsUnderReviewMainContainer.length > 0) {
                    for (let i = 0; i < divsUnderReviewMainContainer.length; i++) {
                        const divToHide = divsUnderReviewMainContainer[i];
                        if (i === 0) continue;
                        if (i === 1) {
                            const reviewSummaryDivs = divToHide.children || [];
                            if (reviewSummaryDivs[0])
                                reviewSummaryDivs[0].style.borderBottom = '1px solid #eaeaea';
                            if (reviewSummaryDivs[2]) reviewSummaryDivs[2].style.display = 'none';
                            continue;
                        }
                        divToHide.style.display = 'none';
                    }
                }
                pageLoadStatus = document.readyState;
            }
        });

    /* istanbul ignore next */
    shouldComponentUpdate(nextProps, newState) {
        if (nextProps.isLoaded !== this.props.isLoaded) {
            return true;
        }
        if (newState.showReviews !== this.state.showReviews) {
            return true;
        }

        return false;
    }

    /* istanbul ignore next */
    componentDidUpdate() {
        const { featureFlags, productDetails } = this.props;
        const { enableShowReviewsButtonOnReviewSection = false } = featureFlags;
        const isReviewAvailable =
            productDetails &&
            productDetails.valuation &&
            productDetails.valuation.reviews &&
            productDetails.valuation.reviews.count > 0;
        if (enableShowReviewsButtonOnReviewSection && isReviewAvailable) {
            if (!this.state.showReviews) {
                const options = {
                    characterData: true,
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeOldValue: true,
                    characterDataOldValue: true,
                };
                this.bvReviewRef &&
                    this.bvReviewRef.current &&
                    this.bvReviewRef.current.shadowRoot &&
                    this.observer.observe(this.bvReviewRef.current.shadowRoot, options);
            } else {
                this.observer.disconnect();
                this.showAllReviews();
            }
        }
    }

    /* istanbul ignore next */
    showAllReviews = () => {
        if (this.bvReviewRef && this.bvReviewRef.current && this.bvReviewRef.current.shadowRoot) {
            const bvReviewMainContainer = this.bvReviewRef.current.shadowRoot.querySelector(
                '#bv_review_maincontainer'
            );
            const divsUnderReviewMainContainer =
                bvReviewMainContainer && bvReviewMainContainer.children;
            const showReviewsButtonContainer = document.querySelector('#BVReviewsContainer');
            const showReviewsutton = showReviewsButtonContainer.querySelector('button');

            showReviewsutton.removeEventListener('click', this.onShowReviewsClick);
            showReviewsutton.remove();

            if (divsUnderReviewMainContainer && divsUnderReviewMainContainer.length > 0) {
                for (let i = 0; i < divsUnderReviewMainContainer.length; i++) {
                    const divToShow = divsUnderReviewMainContainer[i];
                    if (i === 0) continue;
                    if (i === 1) {
                        const reviewSummaryDivs = divsUnderReviewMainContainer[1].children || [];
                        if (reviewSummaryDivs[2]) reviewSummaryDivs[2].style.display = 'block';
                        continue;
                    }
                    if (
                        i === divsUnderReviewMainContainer.length - 1 &&
                        divToShow.childNodes[0]?.textContent === 'Load More'
                    ) {
                        divToShow.style.display = 'flex';
                        continue;
                    }
                    divToShow.style.display = 'block';
                }
            }
        }
    };

    /* istanbul ignore next */
    onShowReviewsClick = () => {
        this.setState({
            showReviews: true,
        });
    };

    /* istanbul ignore next */
    handleAccordionAnalytics(idx, title, newState) {
        let accordionTitle = title;

        if (typeof title === 'object') {
            if (typeof title.props.children === 'string') {
                accordionTitle = title.props.children;
            }

            if (
                typeof title.props.children === 'object' &&
                title.props.children[0] &&
                title.props.children[0].props &&
                title.props.children[0].props.children
            ) {
                accordionTitle = title.props.children[0].props.children;
            }
        }

        const accordionState = newState ? 'collapse' : 'expand';
        this.props.actions.pdpToolClickAnalytics(`${accordionTitle} ${accordionState}`);
    }

    /* istanbul ignore next */
    onAccordionSelect = (idx) => {
        const { enableShowReviewsButtonOnReviewSection = false } = this.props.featureFlags;
        if (
            !this.state.initializeTurnToLib &&
            (idx === questionsIdx || idx === reviewsAccordionIdx)
        ) {
            this.setState({
                initializeTurnToLib: true,
            });
        }
        enableShowReviewsButtonOnReviewSection &&
            idx.target.id === 'accordion-button-0' &&
            (pageLoadStatus === 'complete' || pageLoadStatus === 'interactive') &&
            this.setState({ showReviews: true });
    };

    mobileTabletRenderer() {
        const { dataAutomationId, featureFlags, productDetails, productReviewID } = this.props;

        const ArrayOfAccordionSection = [];

        ArrayOfAccordionSection.push(
            ...renderMobileAccordion(
                featureFlags,
                productDetails,
                productReviewID,
                this.bvReviewRef
            )
        );
        /* istanbul ignore next */

        return (
            <ErrorBoundary>
                <Accordion
                    className={`${cx('rowBlock')} ${dt(['pb-10'])}`}
                    automationId={`${dataAutomationId}-accordion`}
                    onClick={this.onAccordionSelect}
                >
                    {ArrayOfAccordionSection}
                </Accordion>
            </ErrorBoundary>
        );
    }

    render() {
        return this.mobileTabletRenderer();
    }
}

const mapStateToProps = (state) => ({
    deviceType: state.context ? state.context.deviceType : {},
    featureFlags: state.context ? state.context.featureFlags : {},
    infoDetails: ProductInfoSelector(state),
    isMattressSpec: getProductMattressSpec(state),
    productReviewID: selectProductReviewID(state),
    preferences: selectPreferences(state),
    isLoaded: state.BVReviews ? state.BVReviews.isLoaded : false,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...LoaderAction,
            pdpToolClickAnalytics,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductInfo);
